export const mockChats = [
  {
    id: "chat_001",
    patientName: "Rohit Sharma",
    petName: "Bruno",
    avatarInitials: "RB",
    lastMessage: "Hi Doctor, Bruno is feeling better today.",
    lastMessageTime: "10:30 AM",
    unreadCount: 2,
    channel: "whatsapp",
    isOnline: true,
    tab: "all"
  },
  {
    id: "chat_002",
    patientName: "Priya Sharma",
    petName: "Coco",
    avatarInitials: "PC",
    lastMessage: "Shared an image",
    lastMessageTime: "10:15 AM",
    unreadCount: 1,
    channel: "app",
    isOnline: true,
    tab: "unread"
  },
  {
    id: "chat_003",
    patientName: "Ankit Mehta",
    petName: "Bella",
    avatarInitials: "AB",
    lastMessage: "Thank you! 😊",
    lastMessageTime: "Yesterday",
    unreadCount: 0,
    channel: "whatsapp",
    isOnline: false,
    tab: "all"
  },
  {
    id: "chat_004",
    patientName: "Meera Nair",
    petName: "Whisky",
    avatarInitials: "MW",
    lastMessage: "Bill payment confirmed",
    lastMessageTime: "Yesterday",
    unreadCount: 0,
    channel: "app",
    isOnline: false,
    tab: "all"
  },
  {
    id: "chat_005",
    patientName: "Suresh Kumar",
    petName: "Rocky",
    avatarInitials: "SR",
    lastMessage: "When is the next vaccination?",
    lastMessageTime: "Jul 14",
    unreadCount: 3,
    channel: "whatsapp",
    isOnline: false,
    tab: "unread"
  },
  {
    id: "chat_006",
    patientName: "Nisha Patel",
    petName: "Muffin",
    avatarInitials: "NM",
    lastMessage: "Video",
    lastMessageTime: "Jul 14",
    unreadCount: 0,
    channel: "whatsapp",
    isOnline: false,
    tab: "all"
  },
  {
    id: "chat_007",
    patientName: "Karan Johar",
    petName: "Max",
    avatarInitials: "KM",
    lastMessage: "Thanks, will visit tomorrow",
    lastMessageTime: "Jul 13",
    unreadCount: 0,
    channel: "app",
    isOnline: false,
    tab: "all"
  },
  {
    id: "chat_008",
    patientName: "+91 98765 43210",
    petName: "",
    avatarInitials: "P",
    lastMessage: "New Lead",
    lastMessageTime: "Jul 12",
    unreadCount: 0,
    channel: "whatsapp",
    isOnline: false,
    tab: "all"
  },
  {
    id: "chat_009",
    patientName: "Clinic General",
    petName: "",
    avatarInitials: "CG",
    lastMessage: "Team meeting at 4 PM today",
    lastMessageTime: "Jul 11",
    unreadCount: 0,
    channel: "app",
    isOnline: false,
    tab: "mentions"
  },
  {
    id: "chat_010",
    patientName: "Sneha Sen",
    petName: "Oreo",
    avatarInitials: "SO",
    lastMessage: "Thanks a lot! 🙏",
    lastMessageTime: "Jul 10",
    unreadCount: 0,
    channel: "whatsapp",
    isOnline: false,
    tab: "followups"
  }
];

export const mockConversations = {
  chat_001: [
    {
      id: "msg_1",
      sender: "patient",
      type: "text",
      content: "Hi Doctor, Bruno is feeling better today. He has more energy and appetite. 😋",
      timestamp: "10:28 AM",
      date: "Today"
    },
    {
      id: "msg_2",
      sender: "doctor",
      type: "text",
      content: "That's great to hear! Please continue the medication for 2 more days and keep monitoring.",
      timestamp: "10:29 AM",
      status: "read",
      date: "Today"
    },
    {
      id: "msg_3",
      sender: "patient",
      type: "text",
      content: "Sure Doctor. Also sharing his stool sample report.",
      timestamp: "10:30 AM",
      date: "Today"
    },
    {
      id: "msg_4",
      sender: "patient",
      type: "document",
      fileName: "Bruno_Stool_Report.pdf",
      fileSize: "1.2 MB",
      fileType: "PDF",
      timestamp: "10:30 AM",
      date: "Today"
    },
    {
      id: "msg_5",
      sender: "doctor",
      type: "text",
      content: "Thanks for sharing. I'll review and let you know.",
      timestamp: "10:30 AM",
      status: "read",
      date: "Today"
    },
    {
      id: "msg_6",
      sender: "system",
      type: "reminder",
      title: "Follow-up on stool report",
      time: "18 Jul 2024, 10:00 AM",
      date: "Today"
    }
  ],
  chat_002: [
    {
      id: "msg_201",
      sender: "patient",
      type: "text",
      content: "Hello Doctor, Coco is refusing to eat since morning.",
      timestamp: "10:10 AM",
      date: "Today"
    },
    {
      id: "msg_202",
      sender: "doctor",
      type: "text",
      content: "Please check if Coco has a fever or is vomiting.",
      timestamp: "10:12 AM",
      status: "read",
      date: "Today"
    },
    {
      id: "msg_203",
      sender: "patient",
      type: "text",
      content: "Shared an image of her stool.",
      timestamp: "10:15 AM",
      date: "Today"
    }
  ]
};

export const mockPatientDetails = {
  id: 103,
  userId: 103,
  name: "Rohit Sharma",
  userName: "Rohit Sharma",
  phone: "9876543210",
  userMobile: "9876543210",
  email: "rohit.sharma@email.com",
  secondaryMobile: "",
  address: "Porvorim, Goa",
  clientSince: "Jan 2024",
  avatarInitials: "RS"
};

export const mockPetDetails = {
  name: "Bruno",
  breed: "Labrador Retriever",
  gender: "Male",
  age: "3Y 2M",
  patientId: "PT-000248",
  avatarInitials: "B"
};

export const mockRecentVisits = [
  {
    date: "10 Jul 2024",
    type: "OP Consultation",
    doctor: "Dr. Leena Sharma",
    status: "Completed"
  }
];

export const mockInvoices = [
  { id: "INV-2024-1256", date: "10 Jul 2024", amount: "₹2,450", status: "Paid" },
  { id: "INV-2024-1189", date: "28 Jun 2024", amount: "₹1,850", status: "Paid" },
  { id: "INV-2024-1056", date: "15 Jun 2024", amount: "₹3,200", status: "Paid" }
];

export const mockShortcuts = [
  { label: "Send Invoice", action: "send_invoice" },
  { label: "Send EMR", action: "send_emr" },
  { label: "Send Lab Report", action: "send_lab_report" },
  { label: "Appointment Summary", action: "appointment_summary" },
  { label: "Set Reminder", action: "set_reminder" },
  { label: "Share Payment Link", action: "share_payment_link" }
];
